// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main.expanded[data-v-85c4076e]{margin-left:56px}main.reduced[data-v-85c4076e]{margin-left:256px}main #main-container-dashboard[data-v-85c4076e]{height:calc(100vh - 208px);overflow-y:auto}@media only screen and (max-height:768px){main #main-container-dashboard[data-v-85c4076e]{height:calc(100vh - 208px)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
